import { DispositionsFormType, EventPanelMetadata } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';
import { IntegratedFormProvider } from '../../forms/integrated-form-provider';
import { FR_EVENT_DETAILS_TABS } from '../../fr-event-details-page/constants';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { UPDATE_DISPOSITION_DEFAULT_FORM_VALUES } from '../../dispositions/constants';
import { useDispositionQuery } from '../../dispositions/hooks/use-disposition-query';
import { useUpdateDispositionMutation } from '../../dispositions/hooks/use-update-disposition-mutation';

export function FrUnassignCurrentUserUnitContainer(props: { children: React.ReactNode }) {
    const unitAssignment = useUnitAssignment();
    const openFrEventDetails = useOpenFrEventDetails();

    const eventId = unitAssignment?.assignedEvent?.eventId;
    const eventMetadataStore = useEventMetadataStore();

    const { eventId: currentEventId } =
        eventMetadataStore.state.metadata ?? ({} as EventPanelMetadata);

    const dispositionUnitForm = useForm<DispositionsFormType>({
        defaultValues: {
            ...UPDATE_DISPOSITION_DEFAULT_FORM_VALUES,
        },
    });

    const dispositionQuery = useDispositionQuery({ agencyEventId: eventId });
    const updateDispositionMutation = useUpdateDispositionMutation({
        actingTransitioner: 'FIRST_RESPONDER',
        unitIds: unitAssignment?.unitId ? [unitAssignment.unitId] : undefined,
        onMutationSuccess: () => {
            openFrEventDetails(currentEventId, FR_EVENT_DETAILS_TABS.NARRATIVE);
        },
    });

    return (
        <IntegratedFormProvider
            query={dispositionQuery}
            mutation={updateDispositionMutation}
            form={dispositionUnitForm}
        >
            {props.children}
        </IntegratedFormProvider>
    );
}
